export const fields = {
  computed: {
    fields() {
      return [
        {
          key: 'columnCheck',
          thClass: 'mc-table--30',
          sortable: false,
        },
        {
          key: 'licensePlate',
          label: this.$t('global.object.licensePlate'),
          sortable: true,
        },
        {
          key: 'vehicleType',
          label: this.$t('global.field.vehicleType'),
          sortable: true,
        },
        {
          key: 'category',
          label: this.$t('global.object.fleetCategory'),
          sortable: true,
        },
        {
          key: 'manufacturer',
          label: this.$t('global.object.manufacture'),
          sortable: true,
        },
      ]
    },
  }
}